import { render } from "./SidebarButton.vue?vue&type=template&id=56606f63&scoped=true"
import script from "./SidebarButton.vue?vue&type=script&lang=js"
export * from "./SidebarButton.vue?vue&type=script&lang=js"

import "./SidebarButton.vue?vue&type=style&index=0&id=56606f63&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56606f63"],['__file',"src/components/navigation/SidebarButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56606f63"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56606f63', __exports__)) {
    api.reload('56606f63', __exports__)
  }
  
  module.hot.accept("./SidebarButton.vue?vue&type=template&id=56606f63&scoped=true", () => {
    api.rerender('56606f63', render)
  })

}


export default __exports__